import { apiClient } from "../api";
import { LoginAuthDto, LoginResponse, TokenStatusResponseDto } from "../generated/client";

export const authLogin = async (user: LoginAuthDto): Promise<LoginResponse> => {
    try {
        const response = await apiClient.auth.login(user);
        return response.data;
    } catch (error) {
        console.error("Error during login:", error);
        throw error;
    }
};

export const getTokenStatus = async (): Promise<TokenStatusResponseDto | null> => {
    try {
        const response = await apiClient.auth.getTokenStatus();
        return response.data;
    } catch (error) {
        console.error("Token Expired:", error);
        return null
    }
};

